@if(visible()){
<div class="space-y-2">
  <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
    [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  <div class="bg-gray-50 rounded-xl p-4 border border-gray-200 hover:border-blue-300 transition-colors duration-200">
    <mat-form-field>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="dateA" placeholder="開始日期" (ngModelChange)="onValueAChanged($event)">
        <input matEndDate [(ngModel)]="dateB" placeholder="結束日期" (ngModelChange)="onValueBChanged($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

    </mat-form-field>
  </div>
</div>
}